import DOMPurify from 'dompurify';

const renderListItem = item => `
      ${item.refinements
    .map(refinement => `<span class="font-semibold">${sanitizeHTML(refinement.label)}</span>`)
    .join('')}
`;
function sanitizeHTML(str) {
  const temp = document.createElement('div');
  temp.textContent = DOMPurify.sanitize(str);
  return temp.innerHTML;
}

export { renderListItem };
